var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import deleteAssetAlias from '../../requests/asset/deleteAssetAlias';
/**
 *
 */
var DeleteAssetAliasCommand = /** @class */ (function (_super) {
    __extends(DeleteAssetAliasCommand, _super);
    function DeleteAssetAliasCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param manualAssetModel ManualAssetModel
     * @param organisationKey string
     * @param intl
     * @return {*}
     */
    DeleteAssetAliasCommand.prototype.execute = function (manualAssetModel, organisationKey, intl) {
        var promise = deleteAssetAlias(organisationKey, manualAssetModel.id);
        this.intl = intl;
        this.manualAssetModel = manualAssetModel;
        promise.then(this.then);
        return promise;
    };
    /**
    *
    * @param response
    */
    DeleteAssetAliasCommand.prototype.then = function (response) {
        //Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.asset.updated' }, Object(this.manualAssetModel)), 'dark', true);
    };
    return DeleteAssetAliasCommand;
}(Command));
export default DeleteAssetAliasCommand;
